import React from 'react';

function ChevronIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='7'
			height='10'
			viewBox='0 0 7 10'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M1.3332 0L0.158203 1.175L3.97487 5L0.158203 8.825L1.3332 10L6.3332 5L1.3332 0Z'
				fill='#9E9E9E'
			/>
		</svg>
	);
}

export default ChevronIcon;
